export default ()=>{
    const accountWrappers = document.querySelectorAll('.account');
    accountWrappers.length >0 ? accountHandle():false;

    function accountHandle(){
        accountWrappers.forEach(wrapper =>{
            const buttons = document.querySelectorAll('[data-tab-active]');
            const tabs = document.querySelectorAll('[data-tab-name]');
            buttons.forEach(button =>{
                button.addEventListener('click', ()=>{
                    const activeTab = button.dataset.tabActive;
                    setActiveAnchor(activeTab);
                })
            })
            function setActiveAnchor(anchor){
                buttons.forEach(but =>{
                    but.classList.remove('active')
                })
                tabs.forEach((tab, ind) =>{
                    const tabName = tab.dataset.tabName;
                    if(tabName == anchor){
                        tab.classList.add('active');
                        buttons[ind].classList.add('active')
                    } else {
                        tab.classList.remove('active');
                    }
                })
            }
            getAnchor()?setActiveAnchor(getAnchor()):false;
        })
    }

    function getAnchor() {
        var currentUrl = document.URL,
        urlParts   = currentUrl.split('#');
            
        return (urlParts.length > 1) ? urlParts[1] : false;
    }

    
}